import React, { Component } from 'react';

class LatestBlogPost extends Component {
  state = {
    latestPost: null,
    loading: true,
    error: null
  };

  componentDidMount() {
    this.fetchLatestPost();
  }

  fetchLatestPost = async () => {
    try {
      // Fetch RSS feed
      const rssResponse = await fetch('https://api.allorigins.win/get?url=' + encodeURIComponent('https://blog.perfetti.dev/rss.xml'));
      const rssData = await rssResponse.json();
      
      const parser = new DOMParser();
      const xmlDoc = parser.parseFromString(rssData.contents, 'text/xml');
      
      const items = xmlDoc.getElementsByTagName('item');
      if (items.length > 0) {
        const firstItem = items[0];
        const title = firstItem.getElementsByTagName('title')[0]?.textContent;
        const link = firstItem.getElementsByTagName('link')[0]?.textContent;
        const description = firstItem.getElementsByTagName('description')[0]?.textContent;
        const pubDate = firstItem.getElementsByTagName('pubDate')[0]?.textContent;
        
        // Fetch the actual blog post page to get the hero image
        let imageUrl = null;
        try {
          const pageResponse = await fetch('https://api.allorigins.win/get?url=' + encodeURIComponent(link));
          const pageData = await pageResponse.json();
          const html = pageData.contents;
          
          // Look for the first content image (hero image)
          const heroMatch = html.match(/<img[^>]+src="([^"]*\.(webp|jpg|jpeg|png|avif))"/);
          if (heroMatch) {
            const src = heroMatch[1];
            // Make absolute URL if relative
            imageUrl = src.startsWith('http') ? src : 'https://blog.perfetti.dev' + src;
          }
        } catch (imgError) {
          console.error('Error fetching blog post page for image:', imgError);
        }

        // Teaser: get first two sentences
        const cleanText = description?.replace(/<[^>]*>/g, '').trim();
        
        this.setState({
          latestPost: {
            title,
            link,
            description: cleanText ? cleanText + '...' : '',
            imageUrl,
            pubDate: new Date(pubDate).toLocaleDateString('en-US', { 
              year: 'numeric', 
              month: 'long', 
              day: 'numeric' 
            })
          },
          loading: false
        });
      } else {
        this.setState({ loading: false, error: 'No posts found' });
      }
    } catch (error) {
      console.error('Error fetching blog post:', error);
      this.setState({ loading: false, error: 'Failed to load latest post' });
    }
  };

  render() {
    const { latestPost, loading, error } = this.state;

    if (loading) {
      return (
        <div className="card shadow mx-auto mt-4">
          <div className="card-body p-0">
            <h5 className="title2 font-italic text-center mb-4 pt-3">Latest from My Blog</h5>
            {/* Skeleton shimmer placeholder */}
            <div className="blog-skeleton">
              <div className="skeleton-img"></div>
              <div className="skeleton-content">
                <div className="skeleton-badge"></div>
                <div className="skeleton-title"></div>
                <div className="skeleton-text"></div>
                <div className="skeleton-text short"></div>
                <div className="skeleton-btn"></div>
              </div>
            </div>
          </div>
        </div>
      );
    }

    if (error) {
      return (
        <div className="card shadow mx-auto mt-4">
          <div className="card-body text-center">
            <h5 className="title2 font-italic">Latest Blog Post</h5>
            <p>
              <a 
                href="https://blog.perfetti.dev" 
                target="_blank" 
                rel="noopener noreferrer"
                className="link"
              >
                Visit my blog →
              </a>
            </p>
          </div>
        </div>
      );
    }

    return (
      <div className="card shadow mx-auto mt-4">
        <div className="card-body p-0">
          <h5 className="title2 font-italic text-center mb-4 pt-3">Latest from My Blog</h5>
          {latestPost && (
            <div>
              {/* Thumbnail */}
              {latestPost.imageUrl && (
                <div style={{ height: '200px', overflow: 'hidden' }}>
                  <img 
                    src={latestPost.imageUrl} 
                    alt={latestPost.title}
                    className="w-100 h-100"
                    style={{ objectFit: 'cover', objectPosition: 'center' }}
                    onError={(e) => { e.target.style.display = 'none'; }}
                  />
                </div>
              )}

              <div className="p-4">
                <div className="d-flex justify-content-between align-items-start mb-3">
                  <span className="badge badge-primary">{latestPost.pubDate}</span>
                </div>
                
                <h5 className="card-title mb-3">
                  <a 
                    href={latestPost.link} 
                    target="_blank" 
                    rel="noopener noreferrer"
                    style={{ textDecoration: 'none', color: 'inherit', fontWeight: 'bold' }}
                  >
                    {latestPost.title}
                  </a>
                </h5>
                
                <p className="card-text text-muted mb-4" style={{ lineHeight: '1.6' }}>
                  {latestPost.description}
                </p>
                
                <div className="d-flex justify-content-between align-items-center">
                  <a 
                    href={latestPost.link} 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="btn btn-primary"
                  >
                    Read Full Post →
                  </a>
                  <a 
                    href="https://blog.perfetti.dev" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="btn btn-outline-primary"
                  >
                    View All Posts
                  </a>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default LatestBlogPost;
